import assertUnreachable from '@iconik-io/core/src/assert_unreachable';

import {
  type AssetsHttpPostCollectionsQuery,
  httpPostCollections,
} from '../services/assets';
import type { ApplyAcls } from './assets';
import type { IconikApiSdkMethodOptionsWithParams } from './types';

type CreateCollectionParams = {
  title: string;
  parentId?: string;
  applyAcls?: ApplyAcls;
};

export function createCollection({
  client,
  params: { title, parentId, applyAcls = 'unspecified' },
  abortSignal,
}: IconikApiSdkMethodOptionsWithParams<CreateCollectionParams>) {
  const query: AssetsHttpPostCollectionsQuery = {};
  switch (applyAcls) {
    case 'collection':
      query.apply_collection_acls = true;
      break;
    case 'default':
      query.apply_default_acls = true;
      query.restrict_collection_acls = true;
      break;
    case 'private':
      query.apply_default_acls = false;
      query.apply_collection_acls = false;
      break;
    case 'unspecified':
      break;
    default:
      assertUnreachable(applyAcls);
  }
  return client.request(
    httpPostCollections({ title, parent_id: parentId }, query),
    { abortSignal },
  );
}
